import { FIELD_VER_MARGIN } from "@components/inputs/field/Field.styles";
import { ContentColumn } from "@components/objectList/ListItem.styles";
import styled, { css } from "styled-components";

import { T_PLAIN_big } from "../../global.style";

export const StyledDialogListItem = styled.div<{
    disableOverlay?: boolean;
    isInDialog?: boolean;
}>`
    display: flex;
    opacity: ${props => props.disableOverlay ? props.theme.disabled_opacity : 1};
    margin-top: ${FIELD_VER_MARGIN};
    justify-content: flex-start;

    & > ${ContentColumn} {
        &:first-of-type {
            margin-left: 12px; // align with input label
        }

        &:last-of-type {
            margin-right: 0;
        }

        width: fit-content;
        margin-bottom: 0;
    }

    ${props => props.isInDialog && css`
        flex-direction: column;
        gap: 10px;

        & > ${ContentColumn} {
            margin-left: 12px;
        }
    `};
`;

export const StyledPermissionRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    column-gap: 5px;
    ${T_PLAIN_big}
`;